import ProductCategoryPage from './ProductCategoryPage';

export default ProductCategoryPage;
